import React from 'react';
import * as AddressValidationService from '../../../services/address-validation-service';
import { AddressPropType } from '../../../prop-types/address';
import style from '../order-alerts-components.module.less';

const ShipTogetherAddress = ({ address }) => (
  <div className={style['ship-together-address']}>{AddressValidationService.transformAddressIntoOneLine(address)}</div>
);

ShipTogetherAddress.propTypes = {
  address: AddressPropType,
};

export default ShipTogetherAddress;
